import { GET_ALL_PACKAGES } from '../actions/types'
const initialState = {
  course_package: {
    docs: [],
    totalDocs: 0,
    limit: 10,
    page: 1,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },
  loading: true,
}
export default function course_pakage(state = initialState, actions) {
  const { type, payload } = actions
  switch (type) {
    case GET_ALL_PACKAGES:
      return {
        ...state,
        course_package: payload,
        loading: false,
      }
    default:
      return state
  }
}
